<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <div class="card tab2-card">
        <div class="card-body tab2-card">
          <div class="form-group row">
            <div class="col-xl-3 col-md-3">
              <label>POD</label>
              <input class="form-control" type="text" disabled [ngModel]="placeCode">
            </div>
            <div class="col-xl-3 col-md-3">
              <label>Numar contract</label>
              <input class="form-control" type="text" disabled [ngModel]="contractNumber">
            </div>
          </div>
          <br>
          <form [formGroup]="indexForm" class="needs-validation" novalidate>
            <h5>Index</h5>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <label>Data citire index</label>
                <input class="form-control" formControlName="indexDate" type="date"
                  [max]="currentDay | date:'yyyy-MM-dd'" onkeydown="return false" />
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Index</label>
                <input class="form-control" formControlName="indexValue" type="text" />
              </div>
              <div class="col-xl-auto">
                <label>Descriere modalitate de completare index de la OR</label>
                <textarea style="width:100%" rows="4" formControlName="indexDescription"></textarea>
              </div>
            </div>
            <div class="form-group row">
              <label>Incărcare foto index (contor)</label>
              <div class="dropzone-custom col-xl-6 col-md-6">
                <div class="dropzone dropzone-primary" appDragDropFileUpload (click)="fileField.click()"
                  (fileDropped)="uploadCounterIndexPhoto($event)">
                  <div class="dz-message needsclick">
                    <i class="fa fa-cloud-upload"></i>
                    <h4 class="mb-0 f-w-600">Apăsați aici și selectați fișierul sau
                      trage-l cu mouse-ul în aceași
                      zonă.</h4>
                    <br>
                    <h4 class="mb-0 f-w-600">Adăugați un fișier, document pdf sau
                      imagine cu următoarele extensii:
                      .jpeg, .jpg, .png</h4>
                  </div>
                  <input type="file" name="avatars" multiple #fileField
                    (change)="uploadCounterIndexPhoto($any($event).target.files)" hidden />
                </div>
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <h4>Foto index</h4>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-8 col-md-8">
                <span class="font-weight-bold">Fisier</span>
              </div>
              <div class="col-xl-2 col-md-2">
                <span class="font-weight-bold">Dimensiune</span>
              </div>
              <div class="col-xl-2 col-md-2">
                <span class="font-weight-bold">Optiuni</span>
              </div>
            </div>
            <div class="form-group row" *ngFor="let document of indexPhotos; let ind = index">
              <div class="col-xl-8 col-md-8">
                <span>{{document.fileName}}</span>
              </div>
              <div class="col-xl-2 col-md-2">
                <span *ngIf="document.fileByteSize">{{document.fileByteSize | fileSize}}</span>
              </div>
              <div class="col-xl-2 col-md-2">
                <a *ngIf="document.file || document.fileUrl" class="link pointer"
                  (click)="documentService.downloadDocument(document)">Descarca</a>
                <td><a class="link pointer" (click)="deleteDocument(indexPhotos, ind)">Sterge</a></td>
              </div>
            </div>
            <br>
            <div class="form-group row mb-0">
              <div class="col-xl-8 col-md-8">
              </div>
              <div class="col-xl-4 col-md-4">
                <button type="button" class="mr-1 btn btn-light button-margin" (click)="onCancel()">Inapoi</button>
                <button type="button" class="btn btn-primary button-margin" (click)="onSubmit()">
                  Salveaza
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Container-fluid Ends-->